import { blockchainAPI } from "../api"
import { safeApiCall } from "../api/offline"

export const loadBalancesStart = (bool) => ({
  type: "LOAD_BALANCES_START",
  isloading: bool,
})

export const loadBalanceSuccess = (balances) => ({
  type: "LOAD_BALANCES_SUCCESS",
  balances,
})

export const loadBalanceError = (error) => ({
  type: "LOAD_BALANCES_ERROR",
  error: error,
})

export function itemsFetchBalances() {
  return async (dispatch, getState) => {
    // const vsla = getState().vsla
    // if (!vsla?.id) {
    //   console.error("Group blockchain object is missing.")
    //   return Promise.reject(new Error("Group blockchain object is missing."))
    // }
    // const url = `/vsla/${vsla?.id}/balance`
    // dispatch(loadBalancesStart(true))
    // try {
    //   // Use safeApiCall to handle caching and offline scenarios
    //   const res = await safeApiCall({ cacheEnabled: true, url }, async () =>
    //     blockchainAPI.get(url),
    //   )
    //   dispatch(loadBalanceSuccess(res.data))
    //   dispatch(loadBalancesStart(false))
    // } catch (error) {
    //   dispatch(loadBalanceError(error))
    //   dispatch(loadBalancesStart(false))
    // }
  }
}
